import { render } from "./App.vue?vue&type=template&id=3283cccc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3283cccc&lang=sass"
script.render = render

export default script